import {memo} from 'react';
import {styled} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import ReactPaginate from 'react-paginate';
import {func, number} from 'prop-types';
import {button14, bgMain, bgAccentTabs, textPrimary, textSecondary} from 'r/Design';
import chevronRightSvg from 'r/icons/chevron-right.svg';

const Wr = styled.div`
  ul {
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
    display: flex;
    align-items: center;
    border-radius: 3px;
  }
  li {
    ${button14}
    color: ${textPrimary};
    &:hover, &.selected {
      background: ${bgMain};
      color: ${textSecondary};
    }
  }
  a {
    border: 1px solid ${bgAccentTabs};
    height: 28px;
    min-width: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-right: none;
    padding: 0 5px;
    box-sizing: border-box;
  }
  a:focus {
    outline: none;
  }
  .previous {
    margin-right: 10px;
  }
  .next {
    margin-left: 10px;
  }
  .previous a, .next a {
    border-radius: 4px;
    border-right: 1px solid ${bgAccentTabs};
  }
  li:nth-child(2) a {
    border-radius: 4px 0 0 4px;
  }
  li:nth-last-child(2) a {
    border-radius: 0 4px 4px 0;
    border-right: 1px solid ${bgAccentTabs};
  }
`;

const NextIcon = styled.svg`
  height: 18px;
  width: 18px;
  mask: url("${chevronRightSvg}");
  mask-size: cover;
  background-color: ${textPrimary};
  `;


export default memo(Paginate);

Paginate.propTypes = forbidExtraProps({
  forcePage: number.isRequired,
  onPageChange: func.isRequired,
  pageCount: number.isRequired,
});

function Paginate({
  forcePage,
  onPageChange,
  pageCount,
}) {
  return (
    <Wr>
      <ReactPaginate
        forcePage={forcePage}
        marginPagesDisplayed={2}
        nextLabel={<NextIcon/>}
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageRangeDisplayed={5}
        previousLabel={<NextIcon style={{transform: 'rotate(180deg)'}}/>}
      />
    </Wr>
  );
}
